import { atom } from "jotai";
export var devToolsOpenedAtom = atom(false);
export var devToolsSizeAtom = atom(0.5);
export var devToolTabIndexAtom = atom("state");